'use client';
import { colors } from '@/styles';
import * as Icon from '@/ui/Icon';
import * as Styled from './styled';
import classNames from 'classnames';

import { TAssociation, ICompareSchemaField } from '@/lib/tabularCompareApi';

type TFieldStatus = 'added' | 'removed' | 'match' | undefined;

const getFieldStatus = (field: ICompareSchemaField): TFieldStatus => {
  const hasLeft = !!field.left;
  const hasRight = !!field.right;

  const isAdded = hasRight && !hasLeft;
  const isRemoved = hasLeft && !hasRight;
  const isMatch = hasLeft && hasRight;

  return isAdded ? 'added' : isRemoved ? 'removed' : isMatch ? 'match' : undefined;
};

const FieldDisplay: React.FC<{ field: ICompareSchemaField }> = ({ field }) => {
  const status = getFieldStatus(field);
  return (
    <Styled.FieldDisplay>
      <div className={status}>{field.name}</div>
    </Styled.FieldDisplay>
  );
};

const FieldDirection: React.FC<{ field: ICompareSchemaField }> = ({ field }) => {
  const status = getFieldStatus(field);

  return (
    <Styled.FieldDirection>
      <div className={classNames('left', status)}>
        <Icon.ArrowLeft size="14" className={classNames('left', status)} />
      </div>
      <div className={classNames('right', status)}>
        <Icon.ArrowRight size="14" />
      </div>
    </Styled.FieldDirection>
  );
};

const SourceField: React.FC<{
  schemaField: ICompareSchemaField;
  associations: TAssociation[];
  toggleKeyField: (field: ICompareSchemaField) => void;
  toggleTargetField: (field: ICompareSchemaField) => void;
  canEdit?: boolean;
}> = ({ schemaField, associations, toggleKeyField, toggleTargetField, canEdit }) => {
  const field = schemaField;
  const association = associations.find(
    // (a) => a.left.elementId === 'left.' + field.name || a.right.elementId === 'right.' + field.name,
    (a) => a.left.name === field.name || a.right.name === field.name,
  );

  const hasLeft = !!schemaField.left;
  const hasRight = !!schemaField.right;
  const keyable = hasLeft && hasRight;

  return (
    <Styled.Field
      id={field.elementId}
      $hasAssociation={!!association}
      // onClick={() => console.log({ association, schemaField })}
    >
      <div className="content">
        <Icon.Key
          style={{ color: keyable ? (association?.isKey ? 'black' : colors.secondary.lightGray3) : 'transparent' }}
          onClick={() => keyable && canEdit && toggleKeyField(field)}
        />
        <Icon.ColumnCompare
          size="20"
          style={{ color: association?.isTarget ? 'black' : colors.secondary.lightGray3 }}
          onClick={() => canEdit && toggleTargetField(field)}
        />
        <FieldDisplay field={field} />
        <FieldDirection field={schemaField} />
      </div>
    </Styled.Field>
  );
};

export default SourceField;
